// extracted by mini-css-extract-plugin
export default {"placeholder":"layout_placeholder__x26dW","content":"layout_content__cluvX","bottom_img":"layout_bottom_img__TkGve","bottom":"layout_bottom__S2oWi"};